<template>
  <div class="main-content">
    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
    <div class="card" v-if="!loading">
      <div class="card-header">
        <h5>Рабочее время смен</h5>
      </div>
      <div class="card-body">
        <table class="table table-hover table-sm">
          <thead>
          <tr>
            <th>Название смены</th>
            <th>Начало</th>
            <th>Конец</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="record in sortArray(records, 'order')">
            <td>({{ record.id }}) {{ record.title }}</td>
            <td>{{ record.start }}</td>
            <td>{{ record.end }}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      loadingColor: this.$constants.LOADING_COLOR,
      loading: false,
      records: null,
    }
  },
  mounted() {
    this.getShifts();
  },
  methods: {
    async getShifts() {
      this.loading = true;
      const {data} = await api.index('/shifts/list');
      if (data.success) {
        this.records = data.records;
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    }
  }
}
</script>
